import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import AuditLogDetails, { useDeleteAuditLogActionButton } from '../../../../shared/AuditLogDetails';

export type ClientActivityDetailsScreenOwnProps = {};

export type ClientActivityDetailsScreenProps = ClientActivityDetailsScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'client-activity-details'>;
};

const ClientActivityDetailsScreen: React.FC<ClientActivityDetailsScreenProps> = ({
    route: {
        params: { auditLogId, clientMedicalProfileId },
    },
}) => {
    const goBack = useGoBack();
    const { deleteAuditLogAction } = useDeleteAuditLogActionButton({
        auditLogId,
        medicalProfileFileId: clientMedicalProfileId,
        onDeleted: goBack,
    });

    return (
        <ActionButtonLayout scrollable actions={[deleteAuditLogAction]}>
            <AuditLogDetails auditLogId={auditLogId} profileId={clientMedicalProfileId} />
        </ActionButtonLayout>
    );
};

export default React.memo(ClientActivityDetailsScreen);
